/**
 * HTTP layer for site hardware commands. Dispatch a sensor operation to a site's
 * unit and read that unit's command log.
 *
 * Contains:
 * - dispatchSensorOperation: send a sensor command to a site's unit
 * - fetchUnitCommandLogPage: paged unit command log
 */
import apiClient from '@sophocles/http-common';

/** Dispatch a named Vantage sensor operation through its owning site service. */
export const dispatchSensorOperation = (siteId, action, sensorNumber) =>
  apiClient
    .post(`/odl-app/sites/${siteId}/unit/sensors-config/actions/`, {
      action,
      ...(sensorNumber == null ? {} : { sensor_number: sensorNumber }),
    })
    .then(res => res.data.data);

// Paginated odl-app unit-command log read used by CommandLogGrid CSV export.
export const fetchUnitCommandLogPage = (siteId, params) =>
  apiClient.get(`odl-app/sites/${siteId}/unit/commands/log/`, { params }).then(res => res.data);
